import NBType, { InferType } from '@netbase/nb-type'
import ServiceResultEntryErrorSchema from './ServiceResultEntryErrorSchema'
import ServiceSchema from './ServiceSchema'

const ServiceResultEntrySchema = NBType.object().shape('ServiceResultEntrySchema', {
  /* @prop */
  data: NBType.freeObject(),
  /* @prop */
  earliestPubTime: NBType.number().nullable(),
  /* @prop */
  error: ServiceResultEntryErrorSchema,
  /* @prop */
  service: ServiceSchema
  /* END */
})
export default ServiceResultEntrySchema
export type ServiceResultEntry = InferType<typeof ServiceResultEntrySchema>
// RESERVE BELOW
export type ServiceResultEntryWith<T> = Omit<ServiceResultEntry, 'data'> & { data: T }
